import * as React from 'react';

// src/api/depsIdentity.ts
function sameDeps(a, b) {
  if (a === b) return true;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i += 1) {
    if (!Object.is(a[i], b[i])) return false;
  }
  return true;
}
function useDepsChanged(deps) {
  const [previous, setPrevious] = React.useState(deps);
  if (sameDeps(previous, deps)) return false;
  setPrevious(deps);
  return true;
}

export { sameDeps, useDepsChanged };
//# sourceMappingURL=chunk-I37XHMWY.js.map
//# sourceMappingURL=chunk-I37XHMWY.js.map